<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" :label="label">
        <div class="col-12 q-mb-sm row gutter-sm">
            <div class="col-4">
                <q-input v-model="inputValue.lat"
                         :name="path"
                         type="number"
                         :color="color"
                         :disable="form.busy || disable || address !== ''"
                         :autofocus="autofocus"
                         :hide-underline="hideUnderline"
                         prefix="Lat:&nbsp;"
                         @input="onInput"></q-input>
            </div>
            <div class="col-4">
                <q-input v-model="inputValue.lng"
                         :name="path"
                         type="number"
                         :color="color"
                         :disable="form.busy || disable || address !== ''"
                         :hide-underline="hideUnderline"
                         prefix="Lng:&nbsp;"
                         @input="onInput"></q-input>
            </div>
            <div class="col-4">
                <div tabindex="-1"
                     class="q-if row no-wrap relative-position q-input q-if-standard q-if-has-content text-highlight">
                    <div class="q-if-baseline">|</div>
                    <div class="q-if-inner col column">
                        <div class="row no-wrap relative-position"><span
                                class="q-if-addon q-if-addon-left q-if-addon-visible">{{ $T('search') }}:&nbsp;</span>
                            <gmap-autocomplete value="Portugal"
                                               class="col q-input-target q-no-input-spinner ellipsis"
                                               @keypress.13.prevent=""
                                               @place_changed="setPlace"/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <GmapMap :center="inputValue"
                 :zoom="16"
                 map-type-id="roadmap"
                 style="width: 100%; height: 400px"
                 @click="setPlaceFrom">
            <GmapMarker :position="inputValue"
                        :draggable="true"
                        @dragend="setPlaceFrom"/>
        </GmapMap>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {QInput} from 'quasar-framework'

    export default {
        name: 'VCoords',

        mixins,

        data() {
            return {
                inputValue: this.value ? this.value : {lat: window.config.google.lat, lng: window.config.google.lng},
                address: '',
                address_2: '',
                city: '',
                zip_code: '',
                geocoder: null
            }
        },

        mounted() {
            this.onInput()
            this.registerWatcher(this.$root)

            this.$gmapApiPromiseLazy(this.$gmapOptions)
                .then(() => {
                    this.$set(this, 'geocoder', new google.maps.Geocoder())
                    if (this.address !== '') this.updateMapCenter()
                })
        },

        props: {
            type: {
                type: String,
                default: 'text'
            },
            minRows: {
                type: Number,
                default: 1
            },
            autofocus: Boolean,
            prefix: String
        },

        components: {
            QInput
        },

        methods: {
            setPlaceFrom(event) {
                this.inputValue = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                }

                this.onInput()
            },

            setPlace(place) {
                if (!place) return

                this.inputValue = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                }

                this.onInput()
            },
            /**
             *
             */
            registerWatcher(root) {
                root.$children.forEach(component => {
                    if (this.componentIsPlace(component)) {
                        const attribute = component.path
                        component.$watch('value', value => this.updateAddress(attribute, value))
                        this.updateAddress(attribute, component.value)
                    }
                    this.registerWatcher(component)
                })
            },

            /**
             *
             */
            componentIsPlace(component) {
                if (component.path === undefined) {
                    return false;
                }
                return ['address', 'address_2', 'city', 'zipcode'].includes(component.path)
            },

            /**
             *
             */
            updateAddress(field, value) {
                this[field] = value || ''
                this.updateMapCenter()
            },

            /**
             *
             */
            updateMapCenter() {
                if (!!this.geocoder && (this.address || this.city || this.zip_code)) {
                    this.geocoder.geocode({
                        address: this.address + ' ' + this.address_2 + ', ' + this.city + ' ' + this.zip_code
                    }, (results, status) => {
                        if (status === 'OK') {
                            this.setPlace(results[0])
                        }
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VCoords.vue